import axios from "axios";
import { useEffect, useState } from "react";

export default function HarvestMaintenance({ onBack, onSelect, plantId, selected_plant_id }) {
  const [selectedPlantId, setSelectedPlantId] = useState("");
  const [plantWeight, setPlantWeight] = useState("");
  const [defoliatedWeight, setDefoliatedWeight] = useState("");
  const [leafWeight, setLeafWeight] = useState("");
  const [infectedWeight, setInfectedWeight] = useState("");
  const [reasonInfected, setReasonInfected] = useState("");
  const [plantWeightDry, setPlantWeightDry] = useState("");
  const [stemWeightDry, setStemWeightDry] = useState("");
  const [leafWeightDry, setLeafWeightDry] = useState("");
  const [infectedWeightDry, setInfectedWeightDry] = useState("");
  const [untrimmedFlower, setUntrimmedFlower] = useState("");
  const [trimmedFlower, setTrimmedFlower] = useState("");
  const [thcTotal, setThcTotal] = useState([]);
  const [thca, setThca] = useState([]);
  const [cbdTotal, setCbdTotal] = useState([]);
  const [cbda, setCbda] = useState([]);
  const [cbgTotal, setCbgTotal] = useState([]);
  const [terpenoidsTotal, setTerpenoidsTotal] = useState([]);
  const [moistureContent, setMoistureContent] = useState([]);
  const [waterActivity, setWaterActivity] = useState([]);
  const [waterActivityLabMaster, setWaterActivityLabMaster] = useState("");
  const [weightBeforeDrying, setWeightBeforeDrying] = useState("");
  const [weightAfterDrying, setWeightAfterDrying] = useState("");
  const [plantCount, setPlantCount] = useState(0);

  // Check if we have multiple plants (from a plot)
  useEffect(() => {
    if (Array.isArray(selected_plant_id)) {
      setPlantCount(selected_plant_id.length);
      console.log(`Found ${selected_plant_id.length} plants for harvest maintenance`);
    }
  }, [selected_plant_id]);

  const org_id = localStorage.getItem("organization");

  const handleUpload = async () => {
    console.log('Selected plant ID:', selected_plant_id);
    try {
        // Create array of plant IDs
        const plantIds = Array.isArray(selected_plant_id) ? selected_plant_id : [selected_plant_id];
        
        // Check which section is open and send data to the appropriate endpoint
        if (openSubs.has("harvest")) {
            // Validate inputs for harvest
            if (!plantWeight) {
                alert("Please enter a plant weight");
                return;
            }
            
            // Calculate leaf weight
            const calculatedLeafWeight = plantWeight && defoliatedWeight ? 
                (parseFloat(plantWeight) - parseFloat(defoliatedWeight)).toFixed(2) : 0;
            
            // Create harvest request
            const harvestData = {
                defoliated_weight_g: parseFloat(defoliatedWeight) || 0,
                infected_reason: reasonInfected,
                infected_weight_g: parseFloat(infectedWeight) || 0,
                leaf_weight_g: parseFloat(calculatedLeafWeight),
                plant_number: parseInt(selectedPlantId || plantId),
                plant_weight_g: parseFloat(plantWeight) || 0,
                plant_id: plantIds
            };
            
            await axios.post(
                `/orgs/${org_id}/maintenance/harvest`,
                harvestData,
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
        } else if (openSubs.has("postHarvest")) {
            // Validate inputs for post-harvest
            if (!plantWeightDry && !stemWeightDry && !leafWeightDry && 
                !infectedWeightDry && !untrimmedFlower && !trimmedFlower) {
                alert("Please enter at least one post-harvest measurement");
                return;
            }
            
            // Calculate trim weight
            const trimWeight = untrimmedFlower && trimmedFlower ? 
                (parseFloat(untrimmedFlower) - parseFloat(trimmedFlower)).toFixed(2) : null;
            
            // Create post-harvest request
            const postHarvestData = {
                plant_id: plantIds,
                plant_number: parseInt(selectedPlantId || plantId),
                plant_weight_dry_g: parseFloat(plantWeightDry) || null,
                stem_weight_dry_g: parseFloat(stemWeightDry) || null,
                leaf_weight_dry_g: parseFloat(leafWeightDry) || null,
                infected_weight_dry_g: parseFloat(infectedWeightDry) || null,
                untrimmed_flower_g: parseFloat(untrimmedFlower) || null,
                trimmed_flower_g: parseFloat(trimmedFlower) || null,
                trim_weight_g: trimWeight ? parseFloat(trimWeight) : null
            };
            
            await axios.post(
                `/orgs/${org_id}/maintenance/postharvest`,
                postHarvestData,
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
        } else if (openSubs.has("chemicalAnalysis")) {
            const chemicalAnalysisRequests = [];
            
            // Check if Valenveras data is available
            if (openSubs.has("valenveras") && (
                thcTotal.some(v => v) || thca.some(v => v) || cbdTotal.some(v => v) || 
                cbda.some(v => v) || cbgTotal.some(v => v) || terpenoidsTotal.some(v => v) || 
                moistureContent.some(v => v) || waterActivity.some(v => v)
            )) {
                const results = [];
                
                // Add THC total values
                thcTotal.forEach((value, index) => {
                    if (value) {
                        results.push({
                            parameter_name: "THC total",
                            replicate_no: index + 1,
                            value_num: parseFloat(value),
                            unit: "%"
                        });
                    }
                });
                
                // Add THCa values
                thca.forEach((value, index) => {
                    if (value) {
                        results.push({
                            parameter_name: "THCa",
                            replicate_no: index + 1,
                            value_num: parseFloat(value),
                            unit: "%"
                        });
                    }
                });
                
                // Add CBD total values
                cbdTotal.forEach((value, index) => {
                    if (value) {
                        results.push({
                            parameter_name: "CBD total",
                            replicate_no: index + 1,
                            value_num: parseFloat(value),
                            unit: "%"
                        });
                    }
                });
                
                // Add CBDa values
                cbda.forEach((value, index) => {
                    if (value) {
                        results.push({
                            parameter_name: "CBDa",
                            replicate_no: index + 1,
                            value_num: parseFloat(value),
                            unit: "%"
                        });
                    }
                });
                
                // Add CBG total values
                cbgTotal.forEach((value, index) => {
                    if (value) {
                        results.push({
                            parameter_name: "CBG total",
                            replicate_no: index + 1,
                            value_num: parseFloat(value),
                            unit: "%"
                        });
                    }
                });
                
                // Add Terpenoids total values
                terpenoidsTotal.forEach((value, index) => {
                    if (value) {
                        results.push({
                            parameter_name: "Terpenoids total",
                            replicate_no: index + 1,
                            value_num: parseFloat(value),
                            unit: "%"
                        });
                    }
                });
                
                // Add Moisture content values
                moistureContent.forEach((value, index) => {
                    if (value) {
                        results.push({
                            parameter_name: "Moisture content",
                            replicate_no: index + 1,
                            value_num: parseFloat(value),
                            unit: "%"
                        });
                    }
                });
                
                // Add Water activity values
                waterActivity.forEach((value, index) => {
                    if (value) {
                        results.push({
                            parameter_name: "Water activity (aW)",
                            replicate_no: index + 1,
                            value_num: parseFloat(value),
                            unit: ""
                        });
                    }
                });
                
                if (results.length > 0) {
                    chemicalAnalysisRequests.push({
                        method: "valenveras",
                        plant_id: plantIds,
                        results: results
                    });
                }
            }
            
            // Add LabMaster data if available
            if (openSubs.has("labMaster") && waterActivityLabMaster) {
                chemicalAnalysisRequests.push({
                    method: "labmaster",
                    plant_id: plantIds,
                    results: [
                        {
                            parameter_name: "Water activity (aW)",
                            replicate_no: 1,
                            value_num: parseFloat(waterActivityLabMaster),
                            unit: ""
                        }
                    ]
                });
            }
            
            // Add Loss on Drying data if available
            if (openSubs.has("lossOnDrying") && (weightBeforeDrying || weightAfterDrying)) {
                const results = [];
                
                if (weightBeforeDrying) {
                    results.push({
                        parameter_name: "Weight before drying",
                        replicate_no: 1,
                        value_num: parseFloat(weightBeforeDrying),
                        unit: "g"
                    });
                }
                
                if (weightAfterDrying) {
                    results.push({
                        parameter_name: "Weight after drying",
                        replicate_no: 1,
                        value_num: parseFloat(weightAfterDrying),
                        unit: "g"
                    });
                }
                
                if (weightBeforeDrying && weightAfterDrying) {
                    const lossOnDrying = (parseFloat(weightBeforeDrying) - parseFloat(weightAfterDrying)).toFixed(2);
                    results.push({
                        parameter_name: "Loss on drying",
                        replicate_no: 1,
                        value_num: parseFloat(lossOnDrying),
                        unit: "g"
                    });
                }
                
                if (moistureContent[0]) {
                    results.push({
                        parameter_name: "Moisture content",
                        replicate_no: 1,
                        value_num: parseFloat(moistureContent[0]),
                        unit: "%"
                    });
                }
                
                if (results.length > 0) {
                    chemicalAnalysisRequests.push({
                        method: "loss_on_drying",
                        plant_id: plantIds,
                        results: results
                    });
                }
            }
            
            if (chemicalAnalysisRequests.length > 0) {
                await axios.post(
                    `/orgs/${org_id}/maintenance/chemical-analysis`,
                    chemicalAnalysisRequests,
                    {
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );
            } else {
                alert("No valid chemical analysis data to submit");
                return;
            }
        } else {
            alert("Please select a maintenance category");
            return;
        }
        
        alert('Upload complete');
        onBack && onBack(); // Return to previous screen after successful upload
    } catch (err) {
        console.error('Upload failed:', err);
        if (err.response?.status === 400) {
                alert('Upload failed - Check if all required fields are filled in correctly');
            } else if (err.response?.status === 401 || err.response?.status === 403) {
                alert("Upload failed - You are no longer logged in or you don't have access to this resource");
            } else if (err.response?.status === 500) {
                alert("Upload failed - Something went wrong in the service, please try again later");
            } else {
                alert(`Upload failed with error: ${err.response}`);
            }
    }
  };

  /* local state that tracks which dropdowns are open ----------------- */
  const [openSubs, setOpenSubs] = useState(new Set());
  const toggle = (key) =>
    setOpenSubs((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });

  useEffect(() => {
    setSelectedPlantId(plantId);
    console.log("plantId", selectedPlantId);
  }, [plantId]);

  /* ------------------------------------------------------------------ */
  return (
    <>
      {/* header & back -------------------------------------------------- */}
      <div className="maintenanceHeader">
        <h3>Harvest/Post-Harvest</h3>
        <button className="uploadMaintenanceBtn" onClick={handleUpload}>Upload</button>
      </div>

      <div className="maintenaceGrid maintenanceList">
        <div className="dropdownBlock">
            <div
                className="purpleBtn extraGridBtn blueBtn"
                onClick={() =>
                    openSubs.size > 0 ? setOpenSubs(new Set()) : onBack()
                }
            >
                {openSubs.size > 0 ? "Back to Categories" : "Back"}
            </div>
            </div>
        
        {plantCount > 1 && (
          <div className="plotMaintenanceNotice">
            Applying harvest maintenance to all plants in plot ({plantCount} plants)
          </div>
        )}
      </div>

      <div className="maintenaceGrid maintenanceList flexMaintenanceGrid" style={{ marginBottom: "20px" }}>
        {!openSubs.has("harvest") &&
        !openSubs.has("postHarvest") &&
        !openSubs.has("chemicalAnalysis") ? (
          <>
            <div className="purpleBox" onClick={() => toggle("harvest")}>
              Harvest
            </div>
            <div className="purpleBox" onClick={() => toggle("postHarvest")}>
              Post Harvest
            </div>
            <div
              className="purpleBox"
              onClick={() => toggle("chemicalAnalysis")}
            >
              Chemical Analysis
            </div>
          </>
        ) : openSubs.has("harvest") ? (
          <table className="maintenanceTable">
            <tbody>
              {/* <tr>
                <td>
                  <p>Plant number:</p>
                </td>
                <td>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={plantIds}
                    readOnly
                  />
                </td>
              </tr> */}
              <tr>
                <td>
                  <p>Plant weight:</p>
                </td>
                <td style={{ position: "relative" }}>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={plantWeight}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*\.?\d*$/.test(value)) {
                        if (
                          value.includes(".") &&
                          value.split(".")[1]?.length > 2
                        ) {
                          return;
                        }
                        setPlantWeight(value);
                      }
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "10.5vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    g
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <p>Defoliated weight:</p>
                </td>
                <td style={{ position: "relative" }}>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={defoliatedWeight}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*\.?\d*$/.test(value)) {
                        if (
                          value.includes(".") &&
                          value.split(".")[1]?.length > 2
                        ) {
                          return;
                        }
                        setDefoliatedWeight(value);
                      }
                    }}
                    />
                    <span
                    style={{
                      position: "absolute",
                      right: "10.5vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                    >
                    g
                    </span>
                    </td>
                    </tr>
                    <tr>
                    <td>
                    <p>Leaf weight:</p>
                    </td>
                    <td style={{ position: "relative" }}>
                    <input
                    className="newMaintenanceInput"
                    type="text"
                    value={plantWeight && defoliatedWeight ? 
                      (parseFloat(plantWeight) - parseFloat(defoliatedWeight)).toFixed(2) : ""}
                    readOnly
                    />
                    <span
                    style={{
                      position: "absolute",
                      right: "10.5vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                    >
                    g
                    </span>
                    </td>
                    </tr>
                    <tr>
                    <td>
                    <p>Infected weight:</p>
                    </td>
                    <td style={{ position: "relative" }}>
                    <input
                    className="newMaintenanceInput"
                    type="text"
                    value={infectedWeight}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*\.?\d*$/.test(value)) {
                        if (
                          value.includes(".") &&
                          value.split(".")[1]?.length > 2
                        ) {
                          return;
                        }
                        setInfectedWeight(value);
                      }
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "10.5vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    g
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <p>Reason Infected:</p>
                </td>
                <td>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={reasonInfected}
                    onChange={(e) => setReasonInfected(e.target.value)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        ) : openSubs.has("postHarvest") ? (
          <table className="maintenanceTable">
            <tbody>
              {/* <tr>
                <td>
                  <p>Plant number:</p>
                </td>
                <td>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={selectedPlantId}
                    readOnly
                  />
                </td>
              </tr> */}
              {[
                {
                  label: "Plant weight dry",
                  value: plantWeightDry,
                  setter: setPlantWeightDry,
                },
                {
                  label: "Stem weight dry",
                  value: stemWeightDry,
                  setter: setStemWeightDry,
                },
                {
                  label: "Leaf weight dry",
                  value: leafWeightDry,
                  setter: setLeafWeightDry,
                },
                {
                  label: "Infected weight dry",
                  value: infectedWeightDry,
                  setter: setInfectedWeightDry,
                },
                {
                  label: "Untrimmed flower",
                  value: untrimmedFlower,
                  setter: setUntrimmedFlower,
                },
                {
                  label: "Trimmed flower",
                  value: trimmedFlower,
                  setter: setTrimmedFlower,
                },
              ].map(({ label, value, setter }) => (
                <tr key={label}>
                  <td>
                    <p>{label}:</p>
                  </td>
                  <td style={{ position: "relative" }}>
                    <input
                      className="newMaintenanceInput"
                      type="text"
                      value={value}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        if (newValue === "" || /^\d*\.?\d*$/.test(newValue)) {
                          if (
                            newValue.includes(".") &&
                            newValue.split(".")[1]?.length > 2
                          ) {
                            return;
                          }
                          setter(newValue);
                        }
                      }}
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: "10.5vw",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#666",
                      }}
                    >
                      g
                    </span>
                  </td>
                </tr>
              ))}
              <tr>
                <td>
                  <p>Trim weight:</p>
                </td>
                <td style={{ position: "relative" }}>
                  <input
                    className="newMaintenanceInput"
                    type="text"
                    value={
                      untrimmedFlower && trimmedFlower
                        ? (
                            parseFloat(untrimmedFlower) -
                            parseFloat(trimmedFlower)
                          ).toFixed(2)
                        : ""
                    }
                    readOnly
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "10.5vw",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    g
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        ) : openSubs.has("chemicalAnalysis") ? (
          <div style={{ width: "100%", marginTop: "0px" }}>
            <div className="maintenaceGrid maintenanceList">
              <div className="dropdownBlock">
              <div
                className="purpleBtn extraGridBtn"
                onClick={() => toggle("valenveras")}
              >
                Valenveras {openSubs.has("valenveras") ? "▲" : "▼"}
              </div>
              {openSubs.has("valenveras") && (
                <table
                  className="maintenanceTable"
                  style={{ width: "100%", marginTop: "10px" }}
                >
                  <thead>
                    <tr>
                      <th>Parameter</th>
                      <th>Replicate 1</th>
                      <th>Replicate 2</th>
                      <th>Replicate 3</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      {
                        name: "THC total",
                        value: thcTotal,
                        setter: setThcTotal,
                      },
                      { name: "THCa", value: thca, setter: setThca },
                      {
                        name: "CBD total",
                        value: cbdTotal,
                        setter: setCbdTotal,
                      },
                      { name: "CBDa", value: cbda, setter: setCbda },
                      {
                        name: "CBG total",
                        value: cbgTotal,
                        setter: setCbgTotal,
                      },
                      {
                        name: "Terpenoids total",
                        value: terpenoidsTotal,
                        setter: setTerpenoidsTotal,
                      },
                      {
                        name: "Moisture content",
                        value: moistureContent,
                        setter: setMoistureContent,
                      },
                      {
                        name: "Water activity (aW)",
                        value: waterActivity,
                        setter: setWaterActivity,
                      },
                    ].map(({ name, value, setter }) => (
                      <tr key={name}>
                        <td>{name}</td>
                        {[1, 2, 3].map((rep) => (
                          <td key={rep}>
                            <input
                              type="text"
                              inputMode="decimal"
                              className="newMaintenanceInput"
                              style={{ width: "90%" }}
                              value={value?.[rep - 1] ?? ""}
                              onChange={(e) => {
                                let val = e.target.value;
                                if (val !== "") {
                                const percentageValue = parseFloat(val);
                                if (percentageValue > 100) {
                                  alert("Percentage should be between 0 and 100");
                                  return;
                                }
                                }

                                if (!/^\d*\.?\d{0,2}$/.test(val)) return;

                                const parts = val.split(".");
                                if (parts.length > 2 || parts[1]?.length > 2)
                                  return;

                                setter((prev) => {
                                  const newValues = [...(prev || [])];
                                  newValues[rep - 1] = val;
                                  return newValues;
                                });
                              }}
                              onKeyDown={(e) => {
                                if (
                                  !(
                                    (e.key >= "0" && e.key <= "9") ||
                                    e.key === "." ||
                                    e.key === "Backspace" ||
                                    e.key === "Delete" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight" ||
                                    e.key === "Tab"
                                  )
                                ) {
                                  e.preventDefault();
                                }

                                const currentValue = e.currentTarget.value;
                                if (
                                  e.key === "." &&
                                  currentValue.includes(".")
                                ) {
                                  e.preventDefault();
                                }

                                const dotIndex = currentValue.indexOf(".");
                                if (
                                  dotIndex !== -1 &&
                                  e.currentTarget.selectionStart > dotIndex &&
                                  currentValue.split(".")[1]?.length >= 2 &&
                                  e.key >= "0" &&
                                  e.key <= "9"
                                ) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <span
                              style={{
                                position: "relative",
                                transform: "translateY(-50%)",
                                color: "#666",
                              }}
                            >
                              {name !== "Water activity (aW)" ? "%" : ""}
                            </span>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              </div>
            </div>
            <div className="maintenaceGrid maintenanceList">
              <div className="dropdownBlock">
              <div
                className="purpleBtn extraGridBtn"
                onClick={() => toggle("labMaster")}
              >
                LabMaster {openSubs.has("labMaster") ? "▲" : "▼"}
              </div>
              {openSubs.has("labMaster") && (
                <table
                  className="maintenanceTable"
                  style={{ width: "100%", marginTop: "10px" }}
                >
                  <tbody>
                    <tr>
                      <td>Water activity (aW)</td>
                      <td>
                        <input
                          type="text"
                          className="newMaintenanceInput"
                          style={{ width: "90%" }}
                          value={waterActivityLabMaster}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (
                              val === "" ||
                              (/^\d*\.?\d*$/.test(val) &&
                                (!val.includes(".") ||
                                  val.split(".")[1]?.length <= 2))
                            ) {
                              setWaterActivityLabMaster(val);
                            }
                          }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
            </div>

            <div className="maintenaceGrid maintenanceList">
              <div className="dropdownBlock">
              <div
                className="purpleBtn extraGridBtn"
                onClick={() => toggle("lossOnDrying")}
              >
                Loss on Drying {openSubs.has("lossOnDrying") ? "▲" : "▼"}
              </div>
              {openSubs.has("lossOnDrying") && (
                <table
                  className="maintenanceTable"
                  style={{ width: "100%", marginTop: "10px" }}
                >
                  <tbody>
                    {[
                      {
                        label: "Weight before drying",
                        value: weightBeforeDrying,
                        setter: setWeightBeforeDrying,
                      },
                      {
                        label: "Weight after drying",
                        value: weightAfterDrying,
                        setter: setWeightAfterDrying,
                      },
                      {
                        label: "Loss on drying",
                        value:
                          weightBeforeDrying && weightAfterDrying
                            ? (
                                parseFloat(weightBeforeDrying) -
                                parseFloat(weightAfterDrying)
                              ).toFixed(2)
                            : "",
                        readonly: true,
                      },
                      {
                        label: "Moisture content",
                        value: moistureContent,
                        setter: setMoistureContent,
                        unit: "%",
                      },
                    ].map(({ label, value, setter, readonly, unit = "g" }) => (
                      <tr key={label}>
                        <td>{label}</td>
                        <td style={{ position: "relative" }}>
                          <input
                            type="text"
                            className="newMaintenanceInput"
                            value={value}
                            onChange={(e) => {
                              if (readonly) return;
                              const val = e.target.value;
                              if (
                                val === "" ||
                                (/^\d*\.?\d*$/.test(val) &&
                                  (!val.includes(".") ||
                                    val.split(".")[1]?.length <= 2))
                              ) {
                                setter(val);
                              }
                            }}
                            readOnly={readonly}
                          />
                          <span
                            style={{
                              position: "absolute",
                              right: "10.5vw",
                              top: "50%",
                              transform: "translateY(-50%)",
                              color: "#666",
                            }}
                          >
                            {unit}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}
